import { Filter } from '../../models';

export const eventsFilter: Filter[] = [
  {
    title: 'Date',
    type: 'date-range',
    minDate: '0001-01-01',
    maxDate: '9999-12-31',
    // DUAL-FIELD OVERLAP CONFIGURATION
    // This creates overlap queries to find events that intersect with user's selected date range
    // Example: User selects Jan 15-20, finds events that start before/on Jan 20 AND end after/on Jan 15
    // Logic: event_start_date <= user_end_date AND event_end_date >= user_start_date
    field: { start: 'event_start_date', end: 'event_end_date' },
  },
  {
    title: 'Location',
    field: 'event_location.keyword',
    metadataField: 'event_location',
    options: [
      { title: 'Online', value: ['Online', 'Online Curtin Connect'], metadataValue: 'online' },
      {
        title: 'Australia',
        value: [
          'Curtin Perth',
          'Curtin Connect',
          'Building 105.434B',
          'WiSTEM Space, Building 205, Room 235, Curtin Perth',
          'Creative Quarter',
          'Curtin St Georges Terrace',
          'Curtin University, TL Robertson Library (Level 7)',
          '105.418',
          'Build 109, Level 2, Curtin Perth',
          'Building 101 (GRS)',
          'Building 708, WMC Conference Centre, 44 MacDonald Street, Kalgoorlie',
          'Curtin Kalgoorlie',
          'Curtin Murray Street',
          'Curtin Stadium',
          'Curtin Stadium reception',
          'Graduate Hall, Kalgoorlie',
          'Hayman Theatre, 302.101, Curtin Perth',
          'Heath Ledger Theatre, State Theatre Centre of Western Australia',
          'John Curtin Gallery, Curtin University',
          'Ken Hall Lecture Theatre',
          'Level 3, Building 418 – School of Design and the Built Environment , Curtin University, 1 Koorliny Way, Bentley WA',
          'Level 3, TL Robertson Library',
          'TL Robertson Library (Building 105), Curtin Perth',
          'The Old Boys School, 139 St Georges Terrace, Perth.',
          'Tim Winton Lecture Theatre Building 213.104',
        ],
        metadataValue: 'australia',
      },
    ],
  },
];
